export interface ExcelExportOptions {
  filename: string;
  sheetName?: string;
  headers: string[];
  data: any[][];
}

export function exportToExcel(
  options: ExcelExportOptions
): void {
  const { filename, headers, data } = options;
  
  const BOM = '\uFEFF';
  const csvRows: string[] = [];
  
  csvRows.push(headers.map(h => `"${h}"`).join(','));
  
  data.forEach(row => {
    const csvRow = row.map(cell => {
      if (cell === null || cell === undefined) return '""';
      const cellStr = String(cell);
      if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
        return `"${cellStr.replace(/"/g, '""')}"`;
      }
      return `"${cellStr}"`;
    });
    csvRows.push(csvRow.join(','));
  });
  
  const csvContent = BOM + csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.xlsx`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
